(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1758],{

/***/ 37296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(24782);

/***/ }),

/***/ 85776:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/meta/jobs/frontend",
      function () {
        return __webpack_require__(22542);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 21879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ue": function() { return /* binding */ ApplyBlock; },
/* harmony export */   "mf": function() { return /* binding */ DualCalloutBlock; }
/* harmony export */ });
/* unused harmony exports H2TextWrapper, CalloutBlock */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94785);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2413);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44725);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26235);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48876);
/* harmony import */ var src_classes_user_auth_Auth__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17502);
/* harmony import */ var src_components_Splash_LDBlock__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91881);
/* harmony import */ var src_components_UI_Links__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47209);
/* harmony import */ var src_lib_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30440);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  font-family: IBM Plex Mono;\n  font-size: 22px;\n  color: inherit;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








function ApplyBlock() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_Splash_LDBlock__WEBPACK_IMPORTED_MODULE_5__/* .LDExternalLinkBlock */ .wm, {
        target: "_blank",
        rel: "noopener noreferrer",
        href: "https://airtable.com/shrlTjF1dFNoi6E6s",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(H2TextWrapper, {
            children: ">> APPLY NOW"
        })
    });
}
var H2TextWrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d66114f2-0"
})(_templateObject());
function CalloutBlock(param) {
    var text = param.text, url = param.url;
    return /*#__PURE__*/ _jsx(Link, {
        href: url,
        passHref: true,
        children: /*#__PURE__*/ _jsx(LDExternalLinkBlock, {
            children: /*#__PURE__*/ _jsx(H2TextWrapper, {
                children: text
            })
        })
    });
}
function DualCalloutBlock() {
    var auth = src_classes_user_auth_Auth__WEBPACK_IMPORTED_MODULE_4__/* .Auth.instance */ .g.instance;
    var authorizationLevel = auth.observe(function(state) {
        return state.authLevel;
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(src_components_Splash_LDBlock__WEBPACK_IMPORTED_MODULE_5__/* .LDBlock */ .zB, {
        style: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-around",
            marginTop: "20px",
            marginBottom: "20px",
            paddingTop: "36px",
            paddingBottom: "36px"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: src_lib_constants__WEBPACK_IMPORTED_MODULE_7__/* .AppRoutes.Register */ .$w.Register,
                passHref: true,
                prefetch: false,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_UI_Links__WEBPACK_IMPORTED_MODULE_6__/* .StyledLink */ .Fg, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(H2TextWrapper, {
                        children: ">> JOIN"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: authorizationLevel === src_lib_constants__WEBPACK_IMPORTED_MODULE_7__/* .AuthLevel.Authorized */ .zG.Authorized ? src_lib_constants__WEBPACK_IMPORTED_MODULE_7__/* .AppRoutes.HomeMine */ .$w.HomeMine : src_lib_constants__WEBPACK_IMPORTED_MODULE_7__/* .AppRoutes.Signin */ .$w.Signin,
                passHref: true,
                prefetch: false,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_UI_Links__WEBPACK_IMPORTED_MODULE_6__/* .StyledLink */ .Fg, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(H2TextWrapper, {
                        children: authorizationLevel === src_lib_constants__WEBPACK_IMPORTED_MODULE_7__/* .AuthLevel.Authorized */ .zG.Authorized ? ">> OPEN APP" : ">> SIGN IN"
                    })
                })
            })
        ]
    });
}


/***/ }),

/***/ 22542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Frontend; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2413);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37296);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var src_components_Splash_ApplyBlock__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21879);
/* harmony import */ var src_components_Splash_Footer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45635);
/* harmony import */ var src_components_Splash_Header__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84366);
/* harmony import */ var src_components_Splash_Layout_PageContainer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92377);
/* harmony import */ var src_components_Splash_Layout_Typography__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91865);
/* harmony import */ var src_components_Splash_LDBlock__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(91881);
/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/ 







function Frontend() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: "Frontend Engineer - Jobs - Vienna Hypertext"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(src_components_Splash_Layout_PageContainer__WEBPACK_IMPORTED_MODULE_5__/* .LDPageContainer */ .R, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Splash_Header__WEBPACK_IMPORTED_MODULE_4__/* .JobPostHeader */ .jl, {
                            jobTitle: "Frontend"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Splash_ApplyBlock__WEBPACK_IMPORTED_MODULE_2__/* .ApplyBlock */ .Ue, {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(src_components_Splash_LDBlock__WEBPACK_IMPORTED_MODULE_7__/* .LDBlock */ .zB, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Splash_Layout_Typography__WEBPACK_IMPORTED_MODULE_6__/* .LDBlockHeading */ .nL, {
                                    children: "Frontend Engineer"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Splash_Layout_Typography__WEBPACK_IMPORTED_MODULE_6__/* .LDBlockSubheading */ .s1, {
                                    children: "About the role"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Splash_Layout_Typography__WEBPACK_IMPORTED_MODULE_6__/* .LDBlockParagraph */ .yC, {
                                    children: "You will be a React engineer. You’ll craft beautiful components and arrange them to build an insanely great user experience. Our goal is nothing less than to build an advanced thought network on top of the internet. We are seeking people who want to use their technical skills to push the boundaries of what is possible on the web."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(src_components_Splash_Layout_Typography__WEBPACK_IMPORTED_MODULE_6__/* .LDBlockParagraph */ .yC, {
                                    children: [
                                        "For example, our app must be able to handle ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                            children: "very"
                                        }),
                                        " large pages in a performant way. Delivering a rich and snappy user experience on a page that has tens of thousands of networked objects is hard, and standard frontend strategies have been inadequate."
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Splash_Layout_Typography__WEBPACK_IMPORTED_MODULE_6__/* .LDBlockParagraph */ .yC, {
                                    children: "Unlike many startups, we aren’t interested in someone who will translate business logic into React components. We are seeking energetic software engineers, who want to build the future of the internet."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Splash_Layout_Typography__WEBPACK_IMPORTED_MODULE_6__/* .LDBlockParagraph */ .yC, {
                                    children: "In addition to your main engineering responsibilities, you might be interested in working with us if you share an interest in design, aesthetics, or the history of ideas, especially the early internet."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Splash_Layout_Typography__WEBPACK_IMPORTED_MODULE_6__/* .LDBlockSubheading */ .s1, {
                                    children: "Qualifications"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(src_components_Splash_Layout_Typography__WEBPACK_IMPORTED_MODULE_6__/* .LDBlockUL */ .Ms, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "Fluent in Javascript/Typescript"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "Hyper-fluent in React"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "You have designed and built applications or other cool things"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "No bad vibes"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Splash_Layout_Typography__WEBPACK_IMPORTED_MODULE_6__/* .LDBlockSubheading */ .s1, {
                                    children: "Bonus Points"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(src_components_Splash_Layout_Typography__WEBPACK_IMPORTED_MODULE_6__/* .LDBlockUL */ .Ms, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "WebGL"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "Next.js"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "Good vibes"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "Strong or original views"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Splash_Layout_Typography__WEBPACK_IMPORTED_MODULE_6__/* .LDBlockSubheading */ .s1, {
                                    children: "Location"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Splash_Layout_Typography__WEBPACK_IMPORTED_MODULE_6__/* .LDBlockParagraph */ .yC, {
                                    children: "We have a very strong preference for in-person work in NYC. With that said, we are open to discussing remote on a case-by-case basis."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Splash_Layout_Typography__WEBPACK_IMPORTED_MODULE_6__/* .LDBlockSubheading */ .s1, {
                                    children: "Compensation"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Splash_Layout_Typography__WEBPACK_IMPORTED_MODULE_6__/* .LDBlockParagraph */ .yC, {
                                    children: "Combo salary+equity, very competitive"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Splash_ApplyBlock__WEBPACK_IMPORTED_MODULE_2__/* .ApplyBlock */ .Ue, {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_Splash_Footer__WEBPACK_IMPORTED_MODULE_3__/* .LDFooter */ .v, {})
                    ]
                })
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2349,9774,2888,179], function() { return __webpack_exec__(85776); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);